var map = {
	"./+.svg": "9142",
	"./-.svg": "3bb8",
	"./add.svg": "eef4",
	"./arrow-right.svg": "50c3",
	"./arrow-yellow.svg": "4520",
	"./arrow.svg": "b94f",
	"./back.svg": "ccfe",
	"./bg/paycard.svg": "359e",
	"./calendar-plus.svg": "119f",
	"./calendar.svg": "1a34",
	"./camera.svg": "0b86",
	"./cart.svg": "6f5d",
	"./checked-green.svg": "9bbc",
	"./checked.svg": "43e7",
	"./chosen.svg": "6e9f",
	"./close-blue.svg": "6888",
	"./close-white.svg": "7be3",
	"./close.svg": "bf37",
	"./creditcards.svg": "16da",
	"./dietitian-contact.png": "da20",
	"./edit.svg": "6582",
	"./filter.svg": "5ee4",
	"./fonts/HKNova-Bold.woff": "0a80",
	"./fonts/HKNova-Bold.woff2": "9350",
	"./fonts/HKNova-ExtraBold.woff": "96b4",
	"./fonts/HKNova-ExtraBold.woff2": "828d",
	"./fonts/HKNova-Light.woff": "ae9f",
	"./fonts/HKNova-Light.woff2": "998f",
	"./fonts/HKNova-Regular.woff": "c61d",
	"./fonts/HKNova-Regular.woff2": "f8ea",
	"./foodplan.svg": "e7fe",
	"./home.svg": "86e6",
	"./info.svg": "07e6",
	"./journal-back.svg": "18fb",
	"./journal.svg": "48e1",
	"./lev-big.svg": "dfce",
	"./lev-circle.svg": "ec05",
	"./lev-logo.svg": "9d12",
	"./lev.svg": "8a91",
	"./mail.svg": "1752",
	"./mastercard.svg": "2112",
	"./mbway.svg": "092e",
	"./multibanco.svg": "95b2",
	"./mylev-nav.svg": "2175",
	"./product-placeholder.png": "dc63",
	"./profile.svg": "b855",
	"./progress.svg": "5d31",
	"./promo-cards/promo-card.png": "d39a",
	"./promo-cards/promo-card2.png": "1ff6",
	"./search.svg": "51f2",
	"./settings.svg": "e9b0",
	"./shop/all.svg": "2500",
	"./shop/discount.svg": "01ff",
	"./shop/elixir.svg": "2416",
	"./shop/frozen.svg": "cda2",
	"./shop/gluten.svg": "11b6",
	"./shop/new.svg": "a923",
	"./shop/selected.svg": "f153",
	"./shop/sweets.svg": "27ac",
	"./shop/tea.svg": "5199",
	"./shop/water.svg": "6aeb",
	"./shopping-bag.svg": "c4b8",
	"./sms.svg": "58e4",
	"./sun.svg": "3f73",
	"./sunrise.svg": "61e0",
	"./sunset.svg": "3e62",
	"./visa.svg": "0239",
	"./whatsapp.svg": "3357",
	"./youtube.svg": "73dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";